/* eslint-disable max-lines-per-function */

import { Modal, ModalCancelButton, ModalCloseButton, ModalWidth, StyledFlex } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import {
   AppointmentBeginDateTextView,
   AppointmentPatientTextView,
   AppointmentPractitionerTextView,
} from '~libs.desktop.shared.appointment';

import { translationKeys } from '../translations';

import { VisitCancelNotConfirmedModalLoader } from './VisitCancelNotConfirmedModal.loader';
import { VisitCancelNotConfirmedAndPatientSuspendModalConfirmButton } from './VisitCancelNotConfirmedAndPatientSuspendModalConfirmButton';
import { VisitCancelNotConfirmedAndPatientRestoreModalConfirmButton } from './VisitCancelNotConfirmedAndPatientRestoreModalConfirmButton';

type VisitCancelNotConfirmedModalProps = Readonly<{
   appointmentId: number;
   onSuccess: VoidFunction | undefined;
   onClose: VoidFunction;
}>;

export const VisitCancelNotConfirmedModal = (props: VisitCancelNotConfirmedModalProps): JSX.Element => {
   return (
      <Modal
         testId={'visitCancelNotConfirmed'}
         title={translationKeys.cancellingVisitFromWaitlist}
         width={ModalWidth.WIDE}
      >
         <VisitCancelNotConfirmedModalLoader appointmentId={props.appointmentId}>
            {({ appointmentDetails }) => (
               <StyledFlex gap={20} direction={'column'}>
                  <Translate>{translationKeys.thisReservationIsConnectedWithWaitlistEntry}</Translate>

                  <StyledFlex gap={'20px'}>
                     <AppointmentBeginDateTextView beginDate={appointmentDetails.beginDate} />
                     <AppointmentPatientTextView patient={appointmentDetails.patient} />
                  </StyledFlex>
                  <AppointmentPractitionerTextView practitioner={appointmentDetails.practitioner} />

                  <VisitCancelNotConfirmedAndPatientSuspendModalConfirmButton
                     appointmentId={props.appointmentId}
                     onSuccess={props.onSuccess}
                  />
                  <VisitCancelNotConfirmedAndPatientRestoreModalConfirmButton
                     appointmentId={props.appointmentId}
                     onSuccess={props.onSuccess}
                  />
               </StyledFlex>
            )}
         </VisitCancelNotConfirmedModalLoader>
         <ModalCancelButton onClick={props.onClose} />
         <ModalCloseButton onClick={props.onClose} />
      </Modal>
   );
};
